<div class="mobile-step-one mobile-filters">
  <div class="mobile-step-one__main">
    <div class="mobile-step-one__search-box">
      <lib-search-box
        placeholderText="searchSubscription.search.label"
        [radiusOptions]="radiusOptions"
        [forceHideRadius]="false"
        [withChips]="false"
      ></lib-search-box>

      <div class="mobile-step-one__chips" *ngIf="regions.length > 0">
        <ul class="mobile-step-one__chip-list">
          <li
            class="mobile-step-one__chip-item"
            *ngFor="let region of regions; trackBy: trackByRegion"
          >
            <lib-removable-chip (remove)="removeRegionFilter(region)">
              {{ region.name }}
            </lib-removable-chip>
          </li>
        </ul>

        <button
          class="mobile-step-one__reset-chips"
          (click)="resetAllRegions()"
        >
          {{ 'filters.common.reset' | i18n }}
        </button>
      </div>
    </div>

    <div class="mobile-step-one__filters">
      <div class="mobile-step-one__row">
        <lib-contract-type-switch
          [currentOption]="filterState.contractType.filter"
          [options]="filterState.contractType.options"
          (update)="onContractTypeChange($event)"
        >
        </lib-contract-type-switch>
      </div>

      <div class="mobile-step-one__row">
        <lib-category-filter
          (update)="onCategoryChange($event)"
        ></lib-category-filter>

        <div
          class="mobile-step-one__subcategory"
          *ngIf="displaySubcategory"
          [class.mobile-step-one__subcategory--visible]="isCategoryActive"
        >
          <lib-subcategory-filter
            [visibleCount]="3"
            [categoryFilter]="filterState.category.main.filter"
            (update)="onSubcategoryChange($event)"
          ></lib-subcategory-filter>
        </div>
      </div>

      <div class="mobile-step-one__row">
        <lib-price-filter (update)="onPriceChange($event)"></lib-price-filter>
      </div>

      <div class="mobile-step-one__row" *ngIf="displayRoomCount">
        <lib-room-count-filter
          (update)="onRoomCountChange($event)"
        ></lib-room-count-filter>
      </div>

      <div class="mobile-step-one__row" *ngIf="displayLivingSpace">
        <lib-living-space-filter
          (update)="onLivingSpaceChange($event)"
        ></lib-living-space-filter>
      </div>

      <div class="mobile-step-one__row" *ngIf="displayUsageSpace">
        <lib-usage-space-filter
          (update)="onUsageSpaceChange($event)"
        ></lib-usage-space-filter>
      </div>

      <div class="mobile-step-one__row" *ngIf="displayPropertySpace">
        <lib-property-space-filter
          (update)="onPropertySpaceChange($event)"
        ></lib-property-space-filter>
      </div>

      <div class="mobile-step-one__row">
        <button class="mobile-step-one__reset-all" (click)="resetAll()">
          {{ 'filters.common.resetAll' | i18n }}
        </button>
      </div>
    </div>
  </div>
</div>
